import { render } from "./account-forms.vue?vue&type=template&id=5f14cac7"
import script from "./account-forms.vue?vue&type=script&lang=js"
export * from "./account-forms.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/bio-effect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__